import { lazy } from 'react';

import AssistanceAnalysisContainer from '../container/AssistanceAnalysisContainer'
import AssistanceAnalysisReportsContainer from '../container/AssistanceAnalysisReportsContainer'
import AssistanceContainer from '../container/AssistanceContainer'
import AssistanceDetailsContainer from '../container/AssistanceDetailsContainer'
import AssistanceListContainer from '../container/AssistanceListContainer'
import AssistanceToResolveContainer from '../container/AssistanceToResolveContainer'
import BarometroDetailsContainer from '../container/BarometroDetailsContainer'
import BurnedContainer from '../container/BurnedContainer'
import CalendarContainer from '../container/CalendarContainer'
import ChatContainer from '../container/ChatContainer'
import ClusteredPathTopicsContainer from '../container/ClusteredPathTopicsContainer'
import CompleteESMContainer from '../container/CompleteESMContainer'
import ContentDetailsContainer from '../container/ContentDetailsContainer'
import ContentListContainer from '../container/ContentListContainer'
import ContentPageContainer from '../container/ContentPageContainer'
import DashboardContainer from '../container/DashboardContainer'
import DashboardDetailsContainer from '../container/DashboardDetailsContainer'
import DashboardListContainer from '../container/DashboardListContainer'
import DynamicDashContainer from '../container/DynamicDashContainer'
import ESMCommunityPlanContainer from '../container/ESMCommunityPlanContainer'
import ESMContainer from '../container/ESMContainer'
import ESMDetailsContainer from '../container/ESMDetailsContainer'
import EmbrapaDetailsSuinosContainer from '../container/EmbrapaDetailsSuinosContainer'
import EmbrapaSuinosContainer from '../container/EmbrapaSuinosContainer'
import EvidencesDetailsContainer from '../container/EvidencesDetailsContainer'
import FarmerContainer from '../container/FarmerContainer'
import HistoricContainer from '../container/HistoricContainer'
import IndicatorDetailsContainer from '../container/IndicatorDetailsContainer'
import ODSDashboardContainer from '../container/ODSDashboardContainer'
import ODSSelectContainer from '../container/ODSSelectContainer'
import ProducersJourneyContainer from '../container/ProducersJourneyContainer'
import ProjectAnalysisContainer from '../container/ProjectAnalysisContainer'
import ProjectDashContainer from '../container/ProjectDashContainer'
import ProviderJourneyContainer from '../container/ProviderJourneyContainer'
import QualityContainer from '../container/QualityContainer'
import ReportsContainer from '../container/ReportsContainer'
import ReportsContainerPlatformOne from '../container/ReportsDynamicDashContainer'
import ScaleIndicatorListContainer from '../container/ScaleIndicatorListContainer'
import TermsOfUseListContainer from '../container/TermsOfUseListContainer'
import AssistanceGenerateLinkContainer from '../container/AssistanceGenerateLinkContainer'
import AssistanceLinkFormStepsContainer from '../container/AssistanceLinkFormStepsContainer'
import PlanningContainer from '../container/PlanningContainer';
import { LatestAppointmentsContainer } from '../container/LatestAppointmentsContainer';
import DataSheetGrid from '../container/DatasheetgridContainer';
import FarmerProfileContainer from "../container/FarmerProfileContainer"
import NewAssistanceContainer from "../container/NewAssistanceContainer"
import { SchedulePlanContainer } from '../container/SchedulePlanContainer';
import ActivityHistoryContainer from '../container/ActivityHistoryContainer';
import ProjectSummarycontainer from '../container/ProjectSummaryContainer'
import { FarmerImportContainer } from '../container/FarmerImportContainer';

const containers = {
  AssistanceAnalysisContainer,
  AssistanceAnalysisReportsContainer,
  AssistanceContainer,
  AssistanceDetailsContainer,
  AssistanceListContainer,
  AssistanceToResolveContainer,
  BarometroDetailsContainer,
  BurnedContainer,
  CalendarContainer,
  ChatContainer,
  ClusteredPathTopicsContainer,
  CompleteESMContainer,
  ContentDetailsContainer,
  ContentListContainer,
  ContentPageContainer,
  DashboardContainer,
  DashboardDetailsContainer,
  DashboardListContainer,
  DynamicDashContainer,
  ESMCommunityPlanContainer,
  ESMContainer,
  ESMDetailsContainer,
  EmbrapaDetailsSuinosContainer,
  EmbrapaSuinosContainer,
  EvidencesDetailsContainer,
  FarmerContainer,
  HistoricContainer,
  IndicatorDetailsContainer,
  ODSDashboardContainer,
  ODSSelectContainer,
  ProducersJourneyContainer,
  ProjectAnalysisContainer,
  ProjectDashContainer,
  ProviderJourneyContainer,
  QualityContainer,
  ReportsContainer,
  ReportsContainerPlatformOne,
  ScaleIndicatorListContainer,
  TermsOfUseListContainer,
  LatestAppointmentsContainer,
  AssistanceGenerateLinkContainer,
  AssistanceLinkFormStepsContainer,
  PlanningContainer,
  DataSheetGrid,
  FarmerProfileContainer,
  NewAssistanceContainer,
  SchedulePlanContainer,
  ActivityHistoryContainer,
  ProjectSummarycontainer,
  FarmerImportContainer
}

export default containers